import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'thirdParty',
      type: 'input',
      label: '所属第三方',
      placeholder: '请输入第三方名称'
    },
    {
      field: 'channelName',
      type: 'input',
      label: '渠道名称',
      placeholder: '请输入渠道名称'
    },
    {
      field: 'channelType',
      type: 'select',
      label: '渠道类型',
      placeholder: '请选择渠道类型',
      clearable: true,
      options: [
        { title: '电话资源', value: 'PHONE' },
        { title: '第三方引流', value: 'DRAINAGE' }
      ]
    }
  ]
}
